// El estado de pago de una pieza, en UN solo lugar.
//
// `prendaPagada === null` NO es "no pago": es que su costo va dentro del total del
// plan y no hay un cobro propio que consultar. Son dos cosas distintas, y
// confundirlas le miente al club -- en RAIDERS, sobre los 62 jugadores a la vez,
// tanto en pantalla como en el Excel que sale de aqui.
export const estadoDePago = (entrega = {}) => {
  if (entrega.prendaPagada === true) return { label: 'Pagado', variant: 'success' }
  if (entrega.prendaPagada === false) return { label: 'Sin pagar', variant: 'warning' }
  return { label: 'Sin cobro propio', variant: 'outline' }
}
